/**
 * The interfaces in this file are used to make sure our components have the correct properties
 * defined that are needed to pass to Muuri grid constructor.
 *
 * See Muuri's documentation (https://github.com/haltu/muuri#-table-of-contents) for more details.
 *
 * Add this @Props
 */

// @Element() el: HTMLElement;

// /**
//    * Muuri's grid item selector.
//   */
//  @Prop({reflect: true}) gridItemSelector: string = 'sy-grid-item';

//  /**
//    * Muuri's grid handle selector.
//  */
//  @Prop() gridHandleSelector: string;

//  /**
//    * The element the dragged item should be appended to for the duration of the drag.
//  */
//  @Prop() dragContainerSelector: string;

//  /**
//    * Use to create a landscope grid (expand to right).
//  */
//  @Prop() horizontal: boolean = false;

//  /**
//    * Muuri's grid constructor options.
//  */
//  @Prop() gridOptions: object;

/**
 * Bellow you can see the standart use (recommended) of Muuri's grid in your component.
 */

//  /**
//   * Use to get Muuri grid instance.
//  */
//  @Method()
//  async getGrid() {
//    return this.grid;
//  }

//  private grid;

//  componentDidRender() {
//    if(this.sortable)
//      this.grid = MuuriHelper.createGrid(this);
//  }

//  componentWillUpdate() {
//    MuuriHelper.destroyGrid(this.grid);
//  }

import type { GridOptions } from 'muuri';
import Muuri from 'muuri';

export interface MuuriInterface {
  el: HTMLElement;
  gridItemSelector: string;
  gridHandleSelector?: string | undefined;
  dragContainerSelector?: string | undefined;
  horizontal?: boolean | undefined;
  gridOptions?: { [key: string]: any } | undefined;
  dragCursor?: string;
}

function createGrid(component: MuuriInterface): Muuri {
  let overlayEl: HTMLDivElement;

  function addOverlay() {
    overlayEl = document.createElement('div');
    overlayEl.style.opacity = '0';
    overlayEl.style.top = '0';
    overlayEl.style.left = '0';
    overlayEl.style.height = '100%';
    overlayEl.style.width = '100%';
    overlayEl.style.position = 'absolute';
    overlayEl.style.zIndex = '999999';
    overlayEl.style.cursor = component.dragCursor ?? '';
    document.body.appendChild(overlayEl);
  }

  function removeOverlay() {
    overlayEl?.remove();
  }

  const defaultOptions = {
    dragEnabled: true,
    dragHandle: component.gridHandleSelector ? component.gridHandleSelector : null,
    layoutOnResize: true,
    layout: {
      fillGaps: true,
      horizontal: component.horizontal ? component.horizontal : false,
    },
  };

  let gridConstructorOptions: GridOptions = { ...defaultOptions, ...component.gridOptions };

  if (component.dragContainerSelector) {
    const dragContainer = (component.el.getRootNode() as Element).querySelector(
      component.dragContainerSelector,
    ) as HTMLElement;

    gridConstructorOptions = {
      ...gridConstructorOptions,
      dragContainer,
    };
  }

  const muuriGrid = new Muuri(component.el, {
    items: component.el.querySelectorAll(component.gridItemSelector),
    ...gridConstructorOptions,
  });

  muuriGrid.on('dragStart', () => addOverlay());
  muuriGrid.on('dragEnd', () => removeOverlay());

  return muuriGrid;
}

function destroyGrid(grid: Muuri): void {
  grid.destroy();
}

export const MuuriHelper = {
  createGrid,
  destroyGrid,
};
